import { observer } from 'mobx-react';
import { DetailsList, IDetailsListProps } from 'office-ui-fabric-react/lib/DetailsList';
import { logMountingPerformance } from 'owa-analytics';
import * as React from 'react';
import LoadMoreDataZone, {
    LoadMoreDataComponentProps,
} from 'owa-loadmore-listview/lib/components/LoadMoreDataZone';

export interface LoadMoreDetailsListProps extends LoadMoreDataComponentProps {
    detailsListProps: IDetailsListProps;

    // Draws the loading component at the bottom while fetching more data
    loadingComponent?: JSX.Element;
}

@observer
@logMountingPerformance('LoadMoreDetailsList')
export default class LoadMoreDetailsList extends React.Component<LoadMoreDetailsListProps, any> {
    render() {
        return (
            <LoadMoreDataZone
                className={this.props.className}
                dataSourceId={this.props.dataSourceId}
                totalRows={this.props.detailsListProps.items.length}
                onRenderRows={this.renderRows}
                onLoadMoreRows={this.props.onLoadMoreRows}
                isLoadRowsInProgress={this.props.isLoadRowsInProgress}
                getCanLoadMore={this.props.getCanLoadMore}
                onWillUpdate={this.props.onWillUpdate}
                onDidUpdate={this.props.onDidUpdate}
                currentLoadedIndex={this.props.currentLoadedIndex}
                guardPageCount={this.props.guardPageCount}
            />
        );
    }

    private renderRows = (rowsToRender: number): JSX.Element => {
        const detailsListProps = {
            ...this.props.detailsListProps,
            items: this.props.detailsListProps.items.slice(0, rowsToRender),
        };
        const isLoadInProgress = this.props.isLoadRowsInProgress;

        return (
            <div>
                <DetailsList {...detailsListProps} />
                {isLoadInProgress && this.props.loadingComponent}
            </div>
        );
    };
}
